import React from 'react';
import Button from '../button/button.jsx';
import Modal from '../modal/modal.jsx';
import './OptionConfirmModal.scss';

const OptionConfirmModal = ({
    isOpen,
    title,
    text,
    options,
    handleCancel,
    disabled
}) => {
    return (
        <Modal isOpen={isOpen} onClose={handleCancel} overlayClick={false}>
            <div className="modal-alert">

                <div className="alert-header">
                    <h2>{title}</h2>
                </div>

                <div className="alert-body">
                    <p>{text}</p>
                </div>

                <div className="alert-buttons-column">
                    <div className='alert-buttons-column-options'>
                    {
                        options.map((option, index) => (
                            <Button
                                key={index}
                                text={option.text}
                                onClick={option.action}
                                disabled={disabled}
                            />
                        ))
                    }

                    </div>
                    <Button
                        text="Cancelar"
                        onClick={handleCancel}
                        disabled={disabled}
                        backgroundColor='red'
                    />
                </div>

            </div>
        </Modal>
    );
};

export default OptionConfirmModal;